import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Payables from './Payables';
import Receivables from './Receivables';
import PayableDetailsPage from './PayableDetailsPage';
import ReceivableDetailsPage from './ReceivableDetailsPage';
import Accounting from './Accounting';
import AccountingDetailsPage from './AccountingDetailsPage';

export const FinanceRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/finance/payables" replace />} />
      
      {/* Payables Routes */}
      <Route path="/payables" element={<Payables />} />
      <Route path="/payables/:id" element={<PayableDetailsPage />} />
      
      {/* Receivables Routes */}
      <Route path="/receivables" element={<Receivables />} />
      <Route path="/receivables/:id" element={<ReceivableDetailsPage />} />
      
      {/* Accounting Routes */}
      <Route path="/accounting" element={<Accounting />} />
      <Route path="/accounting/:id" element={<AccountingDetailsPage />} />
      
      <Route path="*" element={<Navigate to="/finance/payables" replace />} />
    </Routes>
  );
}; 